import VCollapse from './VCollapse.vue';

export * from './types';
export default VCollapse;
